import React, { useState, useEffect, useCallback } from "react";
import { BsFillExclamationTriangleFill } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import { BgLoader, InLoader } from '../../ui'
import { useNavigate, useParams, useLocation } from "react-router-dom";
export default function PayProcessing() {
  let { id } = useParams();
  useEffect(() => {
    if (window.opener) {
      setTimeout(
        function() {
          window.opener.popupCallback(id);
          window.close();
        }, 3000);
      
    }
  }, []);


  return (
    <div className="text-center mt-5">
      <BgLoader />
    </div>
  );
}
